import { render } from "./TeamRegistration.vue?vue&type=template&id=f843b6a2"
import script from "./TeamRegistration.vue?vue&type=script&lang=js"
export * from "./TeamRegistration.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__